import { render, staticRenderFns } from "./LeaveModal.vue?vue&type=template&id=f2357c4e&scoped=true"
import script from "./LeaveModal.vue?vue&type=script&lang=js"
export * from "./LeaveModal.vue?vue&type=script&lang=js"
import style0 from "./LeaveModal.vue?vue&type=style&index=0&id=f2357c4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2357c4e",
  null
  
)

export default component.exports